module.exports = __webpack_public_path__ + "assets/img/invitation-text.dacce2bf.png";